{
  "page": {
    "title": "สินค้า",
    "add": "เพิ่มสินค้า",
    "search": "ค้นหาสินค้า…",
    "active": "ใช้งาน",
    "inactive": "ปิด",
    "all": "ทั้งหมด",
    "allCategories": "ทุกหมวด",
    "retry": "ลองใหม่",
    "empty": "ยังไม่มีสินค้า",
    "name": "ชื่อ",
    "category": "หมวด",
    "price": "ราคา",
    "status": "สถานะ"
  },
  "editor": {
    "notFound": "ไม่พบสินค้า",
    "backToProducts": "กลับไปหน้าสินค้า",
    "back": "กลับ",
    "active": "เปิดใช้งาน",
    "save": "บันทึก",
    "saved": "บันทึกแล้ว",
    "saveFailed": "บันทึกไม่สำเร็จ",
    "create": "สร้างสินค้า",
    "created": "สร้างสินค้าแล้ว",
    "createFailed": "สร้างสินค้าไม่สำเร็จ",
    "nameRequired": "กรุณาใส่ชื่อสินค้า",
    "categoryRequired": "กรุณาเลือกหมวดสินค้า",
    "priceRequired": "กรุณาตั้งราคาสินค้าอย่างน้อยหนึ่งรายการ",
    "missingName": "ชื่อสินค้า",
    "missingCategory": "หมวดสินค้า",
    "missingPrice": "ราคาสินค้า (อย่างน้อยหนึ่งรายการ)",
    "completeFields": "กรุณากรอก: {{fields}}",
    "basic": "ข้อมูลพื้นฐาน",
    "name": "ชื่อสินค้า",
    "nameExample": "เช่น เสื้อยืดคอกลม",
    "productSku": "SKU ระดับสินค้า",
    "skuFromName": "จะถูกสร้างจากชื่อสินค้า",
    "category": "หมวดสินค้า",
    "tags": "แท็ก",
    "tagsPlaceholder": "พิมพ์แล้วกด Enter เพื่อเพิ่ม",
    "images": "รูปภาพ",
    "variants": "หมวดตัวเลือก (Variant groups)",
    "skuMatrix": "SKU (ตั้งราคา/คงเหลือ/ต้นทุน ต่อตัวเลือก)",
    "newSkuHint": "ตั้งราคาและจำนวนคงเหลือในแต่ละแถว SKU — ไม่มีตัวเลือกก็ตั้งได้ที่แถว “ค่าเริ่มต้น” · ตั้งคงเหลือมากกว่า 0 เพื่อให้ขายได้",
    "editSkuHint1": "SKU มาจากหมวดตัวเลือกข้างต้น แก้ราคา/คงเหลือ/ต้นทุน/น้ำหนัก/เปิด-ปิดได้ทุกแถว — กดบันทึกครั้งเดียวเพื่อยืนยัน",
    "editSkuHint2": "ตั้ง “คงเหลือ” ให้มากกว่า 0 เพื่อให้ขายได้ — ถ้าเป็น 0 จะสร้างออเดอร์ไม่ได้ และ AI จะตอบว่าสินค้าหมด",
    "actions": "การดำเนินการ",
    "confirmVariants": "ยืนยันการเปลี่ยนตัวเลือกสินค้า",
    "variantsWillRemove": "การเปลี่ยนหมวดตัวเลือกจะลบหรือซ่อน SKU ต่อไปนี้:",
    "variantsRemovalDetail": "SKU ที่ไม่เคยมียอดสั่งซื้อจะถูกลบทันที — SKU ที่มีออเดอร์อ้างถึงจะถูกซ่อน (ปิดใช้งาน)",
    "confirm": "ยืนยัน",
    "cancel": "ยกเลิก",
    "warning": "ระวัง",
    "obsoleteWarning": "การบันทึกจะเปลี่ยนสถานะ {{count}} SKU ที่ไม่ตรงกับหมวดใหม่ — กดบันทึกเพื่อดูรายละเอียดและยืนยัน",
    "defaultOption": "ค่าเริ่มต้น"
  },
  "media": {
    "pending": "ยังไม่อัปโหลด",
    "remove": "ลบรูป",
    "add": "เพิ่มรูป",
    "hint": "รูปภาพสินค้า (สูงสุด {{max}} รูป · ขนาดไฟล์ไม่เกิน 1 MB · รูปแรกใช้เป็นภาพหลัก)"
  },
  "sku": {
    "empty": "SKU จะถูกสร้างอัตโนมัติเมื่อบันทึกสินค้า — เพิ่มหมวดตัวเลือก (ถ้ามี) แล้วกดบันทึก",
    "option": "ตัวเลือก",
    "priceBaht": "ราคา (บาท)",
    "stock": "คงเหลือ",
    "stockAria": "จำนวนคงเหลือ",
    "costBaht": "ต้นทุน (บาท)",
    "weightShort": "น้ำหนัก (ก.)",
    "weightAria": "น้ำหนัก (กรัม)",
    "active": "ใช้งาน",
    "activeAria": "ใช้งาน SKU นี้",
    "new": "ใหม่",
    "retiring": "จะถูกลบ",
    "edited": "แก้ไขแล้ว"
  },
  "variants": {
    "groupPlaceholder": "ชื่อหมวด เช่น สี / ไซส์",
    "maxGroups": "รองรับสูงสุด {{count}} หมวด",
    "addGroup": "เพิ่มหมวด",
    "maxReached": "ครบจำนวนหมวดสูงสุดแล้ว ({{count}} หมวด)",
    "removeGroup": "ลบหมวด",
    "codeGenerated": "รหัสจะถูกสร้างให้",
    "codeFor": "รหัสสำหรับ {{value}}",
    "skuCodeHint": "รหัสสำหรับสร้าง SKU",
    "optionPlaceholder": "เพิ่มตัวเลือก เช่น ขาว / ดำ",
    "add": "เพิ่ม"
  },
  "category": {
    "placeholder": "เลือกหรือค้นหาหมวดสินค้า (ภาษาไทย)"
  },
  "errors": {
    "load": "ไม่สามารถโหลดสินค้าได้",
    "upload": "อัปโหลดไม่สำเร็จ",
    "unsupportedImage": "ไม่รองรับไฟล์รูปนี้ ({{type}}) — กรุณาใช้ JPG, PNG, WebP, GIF, AVIF หรือ HEIC",
    "processImage": "ไม่สามารถประมวลผลรูปภาพได้",
    "saveImage": "ไม่สามารถบันทึกรูปภาพได้"
  }
}
